import React, { useMemo } from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { createTableColumns } from '../../config/resultsTableConfig';

/**
 * ResultsTable Component
 * Displays risk calculation results in a table format
 *
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of ResultRow objects to display
 * @param {Function} props.onEdit - Handler for edit action (null in read-only mode)
 * @param {Function} props.onDuplicate - Handler for duplicate action (null in read-only mode)
 * @param {Function} props.onDelete - Handler for delete action (null in read-only mode)
 * @param {boolean} props.loading - Loading state for the table
 * @param {boolean} props.readOnly - Whether the table is in read-only mode (hides actions)
 */
const ResultsTable = ({
  data = [],
  onEdit,
  onDuplicate,
  onDelete,
  loading = false,
  readOnly = false,
}) => {
  const { t } = useTranslation('riskCalculator');

  // Memoize columns configuration to prevent unnecessary re-renders
  const columns = useMemo(() => {
    return createTableColumns(
      t,
      {
        onEdit,
        onDuplicate,
        onDelete,
      },
      readOnly
    );
  }, [t, onEdit, onDuplicate, onDelete, readOnly]);

  return (
    <Table
      className="risk-results-table"
      columns={columns}
      dataSource={data}
      rowKey="id"
      loading={loading}
      pagination={false}
      scroll={{ x: 'max-content' }}
      bordered
      size="small"
    />
  );
};

export default ResultsTable;
